import logo from './logo.svg';
import './App.css';
import Navegation from './Components/Shared/Navegation/Navegation';
import Home from './Components/Home/Home'
import Dashboard from './Components/Dashboard/Dashboard';
import { Route, Routes } from 'react-router-dom';
import Reviews from './Components/Reviews/Reviews';
import Blogs from './Components/Blogs/Blogs';
import NotFound from './Components/NotFound/NotFound';



function App() {
  return (
    <div className="App">
      <Navegation></Navegation>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="review" element={<Reviews />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="blog" element={<Blogs />} />
        <Route path="/*" element={<NotFound />} />
      </Routes>
     
     
     
    </div>
  );
}

export default App;
